import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { TerraceDesignVM } from './TerraceDesignVM';
import { Nav, NavItem } from 'reactstrap';
import { TerraceDesignProfileView } from '../TerraceDesignProfileView/TerraceDesignProfileView';
import { TerraceDesignAlignmentView } from '../TerraceDesignAlignmentView/TerraceDesignAlignmentView';
import { Route, Switch, useParams, NavLink as RouterNavLink, useRouteMatch } from 'react-router-dom';
import './TerraceDesign.scss';

interface ITerraceProps {
  addTerraceEdits?: any;
  mapView:any;
}

const TerraceDesignComponent = (props: ITerraceProps) => {
  const vm = useRef(new TerraceDesignVM()).current;
  const { projectId }: any = useParams();
  const { terraceId }: any = useParams();
  const { path } = useRouteMatch();

  return (
    <>
      <Nav tabs className="top-tabs pl-3">
        <NavItem>
          <RouterNavLink
            exact
            to={`/design/${projectId}/terrace/${terraceId}/design`}
            className={`usa-button nav-link mr-0 usa-button--outline`}
          >
            Profile View
          </RouterNavLink>
        </NavItem>
        <NavItem>
          <RouterNavLink
            to={`/design/${projectId}/terrace/${terraceId}/design/alignment-view`}
            className={`usa-button nav-link usa-button--outline`}
          >
            Alignment View
          </RouterNavLink>
        </NavItem>
      </Nav>

      <div className="terrace-design-container separator-container" id="separator-container">
        <Switch>
          <Route path={`${path}/alignment-view`}>
            <TerraceDesignAlignmentView />
          </Route>
          <Route exact path={`${path}`}>
            <TerraceDesignProfileView addTerraceEdits={props.addTerraceEdits} mapView={props.mapView}/>
          </Route>
        </Switch>
      </div>
    </>
  );
};

export const TerraceDesign = observer(TerraceDesignComponent);
